import React, { Component } from 'react';
import AirLines from 'components/widgets/autocompletes/airLines';
import TimeSelect from 'components/widgets/autocompletes/select';
import Lang from 'libraries/Lang';
import { getTimes } from '../../helpers/getTime';

import 'react-dates/initialize';

class FlightSearch extends Component {
    constructor(props) {
        super(props);

        this.selectAirline = this.selectAirline.bind(this);
        this.onStopChange = this.onStopChange.bind(this);
        this.onDepartTimeChange = this.onDepartTimeChange.bind(this);
        this.onReturnTimeChange = this.onReturnTimeChange.bind(this);
    }

    selectAirline(selectedAirline) {
        // const { shouldValidate } = this.state;
        // if (shouldValidate) {
        //     this.errorHandler.checkRule('form.departure', selectedDeparture);
        // }
        // this.setState({ selectedDeparture });
        // this.setState({ selectedAirline });
        this.props.setSearchParameter('selectedAirline', selectedAirline);
    }

    onStopChange(event) {
        const { value } = event.target;
        // this.setState({ noOfstop: value });
        this.props.setSearchParameter('noOfstop', value);
    }

    onDepartTimeChange(e) {
        // this.setState({ selectedDepartTime: e.value, departTime: e.text });
        this.props.setSearchParameter('selectedDepartTime', e.value);
        this.props.setSearchParameter('departTime', e.text);
    }

    onReturnTimeChange(e) {
        // this.setState({ selectedReturnTime: e.value, returnTime: e.text });
        this.props.setSearchParameter('selectedReturnTime', e.value);
        this.props.setSearchParameter('returnTime', e.text);
    }

    render() {
        const {
            selectedDepartTime,
            selectedReturnTime,
            noOfstop,
            selectedAirline,
        } = this.props.flightData;

        const times = getTimes();

        return (
            <div className="">
                {/* <div className="font-weight-bold text-dark mb-3">Flight</div> */}
                <div className="tab-pane active in">
                    <div className="row gutter-10 mb-0">
                        <div className="col-12 col-md-6 col-lg-5">
                            <div className="element-container">
                                <div className="row gutter-0">
                                    <div className="col">
                                        <label className="text-label" htmlFor="airline">{Lang.trans('engine_travelgenie.airline')}</label>
                                        <div className="element-wrapper">
                                            <AirLines
                                                id="airline"
                                                placeholder={Lang.trans('engine_travelgenie.airline_placeholder')}
                                                onSelect={this.selectAirline}
                                                label="Airline"
                                                value={selectedAirline}
                                            />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-md-6 col-lg-3">
                            <div className="element-container select-unstyled-container">
                                <label className="text-label" htmlFor="noofstops">{Lang.trans('engine_travelgenie.number_of_stops')}</label>
                                <select className="w-100 select-unstyled" id="noofstops" value={noOfstop} onChange={this.onStopChange}>
                                    <option value="0">0</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                </select>
                                <svg className="icon icon-select" aria-hidden="true"><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/img/icons/icon-defs.svg#icon-chevron-down" /></svg>
                                {/* {errors.form && errors.form.dates && (
                                        <ErrorTooltip error={{ message: errors.form.dates, id: 'dates' }} />
                                    )} */}

                            </div>
                        </div>
                        <div className="col-md-12 col-lg-4">
                            <div className="row gutter-10">
                                <div className="col">
                                    <div className="input-chevron-down">
                                        <div className="element-container select-unstyled-container">
                                            <label className="text-label" htmlFor="departTime">{Lang.trans('engine_travelgenie.depart_time')}</label>
                                            <TimeSelect
                                                id="departTime"
                                                // value='02:30'
                                                value={times.find((obj) => obj.value === selectedDepartTime)} // set selected value
                                                options={times}
                                                name="departTime"
                                                placeholder={Lang.trans('engine_travelgenie.select_time')}
                                                onSelect={this.onDepartTimeChange}
                                                // onSelect={(departTime) => onDepartTimeChange1(departTime)}

                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col">
                                    <div className="input-chevron-down">
                                        <div className="element-container select-unstyled-container">
                                            <label className="text-label" htmlFor="returnTime">{Lang.trans('engine_travelgenie.return_time')}</label>
                                            <TimeSelect
                                                id="returnTime"
                                                value={times.find((obj) => obj.value === selectedReturnTime)} // set selected value
                                                options={times}
                                                name="returnTime"
                                                placeholder={Lang.trans('engine_travelgenie.select_time')}
                                                onSelect={this.onReturnTimeChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FlightSearch;
